/* eslint-disable @typescript-eslint/no-explicit-any */
const validLatLng = (icon: {
  iconPoint: { latitude: number; longitude: number };
  location: { latitude: number; longitude: number };
  locationless?: boolean;
}) => {
  if (!icon.iconPoint && !icon.location) return false;
  if (icon.locationless === true) return false;
  if (icon.iconPoint) {
    return (
      icon.iconPoint.latitude &&
      icon.iconPoint.longitude &&
      !isNaN(icon.iconPoint.latitude) &&
      !isNaN(icon.iconPoint.longitude)
    );
  } else if (icon.location) {
    return (
      icon.location.latitude &&
      icon.location.longitude &&
      !isNaN(icon.location.latitude) &&
      !isNaN(icon.location.longitude)
    );
  }
};

const toLatlng = (icon: any) => {
  if (icon.iconPoint) {
    return { lat: icon.iconPoint.latitude, lng: icon.iconPoint.longitude };
  } else if (icon.location) {
    return { lat: icon.location.latitude, lng: icon.location.longitude };
  }
};

export { validLatLng, toLatlng };
